import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, MaskLines, MaskLinesInView } from "../motion";
import { MARQUEE } from "../content";
import { IMG } from "../assets";

// Interior page hero (dark band)
export const PageHero = ({ eyebrow, titleLines, lead, index }) => (
  <section className="relative bg-ink text-bone pt-40 pb-20 lg:pt-52 lg:pb-28 grain overflow-hidden">
    <div className="absolute inset-0 opacity-40 bg-gradient-to-b from-gold/5 via-transparent to-transparent" />
    <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
      {index && <div className="serif text-gold/25 text-[7rem] lg:text-[11rem] leading-none absolute right-6 lg:right-10 -top-6 select-none">{index}</div>}
      <Reveal>{eyebrow && <div className="eyebrow text-gold mb-6">{eyebrow}</div>}</Reveal>
      <h1 className="display text-5xl sm:text-6xl lg:text-[5.2rem] text-bone max-w-5xl">
        <MaskLines lines={titleLines} delay={0.15} />
      </h1>
      {lead && <Reveal delay={0.15}><p className="mt-8 max-w-2xl text-bone/65 text-lg leading-relaxed font-light">{lead}</p></Reveal>}
    </div>
  </section>
);

export const CTABand = ({ title, text, primaryLabel = "Fale com o escritório", primaryTo = "/contato" }) => (
  <section className="relative bg-ink-deep text-bone py-24 lg:py-32 grain overflow-hidden">
    <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10 grid lg:grid-cols-[1.3fr_1fr] gap-12 items-end">
      <div>
        <div className="eyebrow text-gold mb-6">Contato</div>
        <h2 className="display text-4xl sm:text-5xl lg:text-6xl text-bone max-w-3xl">
          <MaskLinesInView lines={title} />
        </h2>
        {text && <Reveal delay={0.1}><p className="mt-7 max-w-xl text-bone/60 leading-relaxed font-light">{text}</p></Reveal>}
      </div>
      <Reveal delay={0.15} className="flex flex-col lg:items-end gap-8">
        <div className="relative w-full max-w-sm rounded-2xl overflow-hidden aspect-[5/4]">
          <img src={IMG.texture} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink-deep/70 to-transparent" />
        </div>
        <Link to={primaryTo} data-testid="ctaband-primary" className="btn-gold text-base">{primaryLabel} <ArrowRight size={18} /></Link>
      </Reveal>
    </div>
  </section>
);

export const Marquee = () => (
  <div className="bg-ink text-bone border-y border-white/10 py-6 overflow-hidden select-none">
    <div className="marquee-track">
      {[...MARQUEE, ...MARQUEE].map((m, i) => (
        <span key={i} className="serif text-2xl lg:text-3xl px-8 text-bone/70 inline-flex items-center gap-8">
          {m} <span className="text-gold text-lg">✦</span>
        </span>
      ))}
    </div>
  </div>
);

export const AreaChips = ({ slugs, areas }) => (
  <div className="flex flex-wrap gap-2.5">
    {slugs.map((s) => (
      <Link key={s} to={`/atuacao/${s}`} data-testid={`related-${s}`}
        className="group inline-flex items-center gap-1.5 border border-ink/15 rounded-full px-4 py-2 text-sm text-ink/75 hover:border-gold hover:text-ink hover:bg-gold/10 transition-all">
        {areas[s].title} <ArrowUpRight size={14} className="text-gold" />
      </Link>
    ))}
  </div>
);
